<template>
    <div>
        <b-modal
            id="edit-grade-location-modal"
            no-close-on-backdrop
            hide-footer
            size="md"
            centered
            :title="'Assign countries to ' + grade_name"
            v-b-modal.edit-grade-location-modal
            @hidden="resetModal"
            @shown="onModalOpen"
        >
            <div class="modal_content">
                <p class="mb-0">Select Countries</p>
                <v-select
                    class="w-100 mb-1"
                    style="margin-top: 5px"
                    v-model="selectedLocations"
                    multiple
                    :options="listLocations"
                    label="name"
                    :filterable="true"
                >
                </v-select>

                <div class="modal-footer px-0">
                    <b-button
                        @click="saveBtn"
                        :disabled="loading"
                        variant="primary"
                    >
                        <b-spinner v-if="loading" small />
                        Submit
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {
    BButton,
    BFormInput,
    BInputGroup,
    BFormGroup,
    BAlert,
    BSpinner,
} from "bootstrap-vue";
import axios from "axios";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
    components: {
        BButton,
        BFormInput,
        BInputGroup,
        BFormGroup,
        BAlert,
        BSpinner,
        ToastificationContent,
        vSelect,
    },
    data() {
        return {
            baseVuePath: "@view/src/views/components/themes/",
            baseReactNativePath: "@src/components/themes/",
            vuePath: "@view/src/views/components/themes/",
            reactNativePath: "@src/components/themes/",
            errorMsg: "",
            loading: false,
            alertMessageToast: "",
            record: {},
            locations: [],
            selectedLocations: [],
        };
    },
    computed: {
        hasError() {
            return this.errorMsg != "";
        },
        listLocations() {
            return this.locations;
        },
    },
    watch: {
        grade_data: function (newVal) {
            this.getLocations(null);
        },
    },
    methods: {
        onModalOpen() {
            if (this.edit_grade && this.edit_grade.locations) {
                this.edit_grade.locations.forEach((loc) => {
                    this.selectedLocations.push(loc);
                });
            } else {
                this.selectedLocations = [];
            }
        },
        async getLocations(item) {
            this.loading = true;
            try {
                const resp = await axios.post(
                    process.env.VUE_APP_API_URL + "/locations/all",
                    { search: item },
                    {
                        headers: {
                            Authorization:
                                "Bearer " + localStorage.getItem("_t"),
                        },
                    }
                );

                const newLocations = resp.data.countries;
                this.$nextTick(() => {
                    this.locations = newLocations;
                });

                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error("Error fetching users:", error);
            }
        },

        showToast(variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: "Notification",
                    icon: "BellIcon",
                    text: this.alertMessageToast,
                    variant,
                },
            });
        },
        resetModal() {
            this.selectedLocations = [];
            this.users = [];
        },
        async saveBtn() {
            this.loading = true;
            try {
                const resp = await axios.post(
                    process.env.VUE_APP_API_URL + "/assign/grade/location",
                    {
                        grade_id: this.grade_data._id,
                        loc_ids: this.selectedLocations.map((loc) => loc._id),
                    },
                    {
                        headers: {
                            Authorization:
                                "Bearer " + localStorage.getItem("_t"),
                        },
                    }
                );
                this.alertMessageToast = resp.data.message;
                this.showToast("success");
                this.selectedLocations = [];
                this.$emit("getData");
                this.$bvModal.hide("edit-grade-location-modal");
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.alertMessageToast = this.errorMsg;
                this.showToast("danger");
            }
        },
    },
    props: ["grade_data", "edit_early_access", "edit_grade", "grade_name"],
};
</script>
